import styled from 'styled-components';

const StyledWrapper = styled.div`
  float: left;
  display: block;
  width: 48.82117%;
  margin-right: 2.35765%;
  &:last-child {
    margin-right: 0;
  }
`;
const StyledLabel = styled.div`
  padding: 1em;
  border: 1px solid #f4f4f4;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
`;

export { StyledLabel, StyledWrapper };
